import { useEffect, useState } from 'react';
import { commsAPI, mailboxAPI } from '../lib/communicationsAPI';

// Polls the Communications unread count (~15s) and refreshes on 'comms:changed' events.
export function useCommsUnread(enabled = true) {
  const [data, setData] = useState({ unread: 0, folders: {} });
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const load = () => commsAPI.unreadCount().then((r) => alive && setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    window.addEventListener('comms:changed', load);
    return () => { alive = false; clearInterval(t); window.removeEventListener('comms:changed', load); };
  }, [enabled]);
  return data;
}

// Generic polling helper: runs fn now and every `ms` while `enabled`.
export function usePolling(fn, ms, deps, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    fn();
    const t = setInterval(fn, ms);
    return () => clearInterval(t);
  }, [...deps, enabled]);
}

// Mailboxes the current staff user may send from (empty until a provider is configured + connected).
export function useMailboxes(enabled = true) {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!enabled) return;
    mailboxAPI.usable().then((r) => setList(r.data.accounts)).catch(() => setList([]));
  }, [enabled]);
  return list;
}
